"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RSA_jsrsasign = void 0;
var rfc4648_1 = require("rfc4648");
var shared_1 = require("../b64/shared");
var KeyPairBase_1 = require("../KeyPairBase");
var UUID_1 = __importDefault(require("../UUID"));
var jsrsasign_1 = require("jsrsasign");
var AbstractRSA_1 = __importDefault(require("./AbstractRSA"));
var NotSupportedError_1 = require("./NotSupportedError");
var uuidToB64_1 = require("../uuidToB64");
function b64toHexString(b64) {
    return rfc4648_1.base64.parse(b64).reduce(function (acc, byte) {
        return acc + ('0' + (byte & 0xff).toString(16)).slice(-2);
    }, '');
}
function hexToB64String(hex) {
    var binSign = [];
    for (var i = 0; i < hex.length; i += 2)
        binSign.push(parseInt(hex.substring(i, i + 2), 16));
    return rfc4648_1.base64.stringify(binSign);
}
var RSA_jsrsasign = /** @class */ (function (_super) {
    __extends(RSA_jsrsasign, _super);
    function RSA_jsrsasign() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RSA_jsrsasign.prototype.verify = function (pub_key, payload, signature) {
        return __awaiter(this, void 0, void 0, function () {
            var key, sig;
            return __generator(this, function (_a) {
                key = jsrsasign_1.KEYUTIL.getKey(pub_key.data);
                sig = new jsrsasign_1.KJUR.crypto.Signature({ alg: 'SHA256withRSA' });
                sig.init(key);
                sig.updateString(payload);
                return [2 /*return*/, sig.verify(b64toHexString((0, shared_1.unescape)(signature)))];
            });
        });
    };
    RSA_jsrsasign.prototype.sign = function (prv, payload) {
        return __awaiter(this, void 0, void 0, function () {
            var key, sig;
            return __generator(this, function (_a) {
                key = jsrsasign_1.KEYUTIL.getKey(prv.data);
                sig = new jsrsasign_1.KJUR.crypto.Signature({ alg: 'SHA256withRSA' });
                sig.init(key);
                sig.updateString(payload);
                return [2 /*return*/, (0, shared_1.escape)(hexToB64String(sig.sign()))];
            });
        });
    };
    RSA_jsrsasign.prototype.supports = function (mode) {
        switch (mode) {
            case 'decryptPrivate':
            case 'encryptPublic':
            // intentional commenting of this value, not finalized yet
            // return true;
            case 'decryptPublic':
            case 'encryptPrivate':
                return false;
        }
    };
    RSA_jsrsasign.prototype.getMaxEncryptionLength = function () {
        return 50;
    };
    RSA_jsrsasign.prototype.encryptPrivate = function (key, payload) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                throw new NotSupportedError_1.NotSupportedError();
            });
        });
    };
    RSA_jsrsasign.prototype.encryptPublic = function (key, payload) {
        return __awaiter(this, void 0, void 0, function () {
            var _key, h, r;
            return __generator(this, function (_a) {
                _key = jsrsasign_1.KEYUTIL.getKey(key.data);
                h = jsrsasign_1.KJUR.crypto.Cipher.encrypt(payload, _key, 'RSA');
                r = hexToB64String(h);
                return [2 /*return*/, r];
            });
        });
    };
    RSA_jsrsasign.prototype.decryptPrivate = function (key, payload) {
        return __awaiter(this, void 0, void 0, function () {
            var _key, hexPayload, a;
            return __generator(this, function (_a) {
                _key = jsrsasign_1.KEYUTIL.getKey(key.data);
                hexPayload = b64toHexString(payload);
                a = jsrsasign_1.KJUR.crypto.Cipher.decrypt(hexPayload, _key, 'RSA');
                return [2 /*return*/, a];
            });
        });
    };
    RSA_jsrsasign.prototype.decryptPublic = function (key, payload) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                throw new NotSupportedError_1.NotSupportedError();
            });
        });
    };
    RSA_jsrsasign.prototype.generate_new = function () {
        return __awaiter(this, arguments, void 0, function (keylength) {
            var pair, keyid, _a, _b, prv_pem, pub_pem;
            if (keylength === void 0) { keylength = 512; }
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        pair = jsrsasign_1.KEYUTIL.generateKeypair('RSA', keylength);
                        _a = 'key-';
                        _b = uuidToB64_1.uuidToB64;
                        return [4 /*yield*/, (0, UUID_1.default)()];
                    case 1:
                        keyid = _a + _b.apply(void 0, [_c.sent()]);
                        prv_pem = jsrsasign_1.KEYUTIL.getPEM(pair.prvKeyObj, 'PKCS1PRV').replace(/\r/gm, '').trim();
                        pub_pem = jsrsasign_1.KEYUTIL.getPEM(pair.pubKeyObj).replace(/\r/gm, '').trim();
                        return [2 /*return*/, new KeyPairBase_1.KeyPairBase({
                                keyid: keyid,
                                data: prv_pem,
                            }, {
                                keyid: keyid,
                                data: pub_pem,
                            })];
                }
            });
        });
    };
    return RSA_jsrsasign;
}(AbstractRSA_1.default));
exports.RSA_jsrsasign = RSA_jsrsasign;
exports.default = new RSA_jsrsasign();
